import React, { useContext, useState } from "react";
import "../../../assets/css/gcstudent/pdfcard/PDFCARD.css";
import AppContext from "../../../context/AppContext";

const PDFCard = ({ book, index, onClick }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const { baseUrlForFiles } = useContext(AppContext);

  if (!book) return null;

  const imgSrc =
    book.img && !imgFailed
      ? `${baseUrlForFiles}/${book.img}`
      : null;

  return (
    <div
      className="gcStudent-pdf-card"
      onClick={() => onClick && onClick(book)}
      style={{ animationDelay: `${(index || 0) * 0.07}s` }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick && onClick(book)}
    >
      {/* Cover Image */}
      <div className="gcStudent-pdf-card-img-wrapper">
        {imgSrc ? (
          <img
            src={imgSrc}
            alt={book.title}
            className="gcStudent-pdf-card-img"
            onError={() => {
              // TEMP DEBUG: konsi URL 404 hui, check karne ke liye.
              // Images load na ho rhi hoon toh yeh console.error hata dena.
              console.error("PDF cover image failed to load:", imgSrc, "raw book.img:", book.img);
              setImgFailed(true);
            }}
          />
        ) : (
          <div className="gcStudent-pdf-card-placeholder">
            <svg
              width="42"
              height="42"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            >
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" />
              <path d="M14 2v6h6" />
            </svg>
            <span>PDF</span>
          </div>
        )}

        {/* Hover overlay */}
        <div className="gcStudent-pdf-card-overlay">
          <div className="gcStudent-pdf-card-overlay-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path d="M12 16l-4-4h3V4h2v8h3l-4 4z" fill="white" />
              <path d="M20 18H4v2h16v-2z" fill="white" />
            </svg>
          </div>
        </div>
      </div>

      {/* Card Body */}
      <div className="gcStudent-pdf-card-body">
        <span className="gcStudent-pdf-card-dept">{book.dept || "General"}</span>
        <h5 className="gcStudent-pdf-card-title">{book.title}</h5>
        <p className="gcStudent-pdf-card-author">{book.author}</p>

        {/* PDF Badge */}
        <div className="gcStudent-pdf-card-badge">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path d="M12 16l-4-4h3V4h2v8h3l-4 4z" fill="#213b52" />
            <path d="M20 18H4v2h16v-2z" fill="#213b52" />
          </svg>
          <span className="gcStudent-pdf-badge-text">
            {book.pdf_file ? "PDF Available" : "No PDF"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PDFCard;